import React, { useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import { billingV2Styles } from '../BillingV2Style';
import ManageMethodModal from './ManageMethodModal';
import {useDispatch, useSelector} from "react-redux";
import {Button} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import AddPaymentMethodModal from "./AddPaymentMethodModal";
import {fetchUserCardInfo} from "../../../actions/billingAction";
import {cardBrandBgPosition, cardBrandLabel, cardExpiry} from "./utils";

const PaymentMethod = () => {
    const dispatch = useDispatch();
    const [showManageModal, setShowManageModal] = useState(false);
    const classes = billingV2Styles();
    const {userCardInfo} = useSelector((state)=>(state.billingReducer));
    const [showMethodModal, setShowMethodModal] = useState(false);

    return (
        <div className={classes.paymentMethodWrapper}>
            <div className='headerSection'>
                <h5 className='title'>Payment Method</h5>

                {
                    userCardInfo?.customer &&
                    <span style={{display: "flex"}} onClick={() => setShowManageModal(true)}>
                    <EditIcon style={{ color: "#3a414a", cursor: "pointer" }} />
                </span>
                }
            </div>
            
            <div className='cardSection'>
                {
                    userCardInfo?.customer ?
                    <>
                        <div className='cardLogo'>
                            <div className='logo'>
                                <span className={classes.brandIcon} style={{ backgroundPosition: cardBrandBgPosition(userCardInfo?.customer?.card_details) }}></span>
                            </div>
                        </div>

                        <div className='cardDetails'>
                            <div className='cardNumber'>
                                {cardBrandLabel(userCardInfo?.customer?.card_details)}  **** {userCardInfo?.customer?.card_number}
                            </div>

                            <div className='cardExpireDate'>
                                Expires {cardExpiry(userCardInfo?.customer?.card_details)}
                            </div>
                        </div>

                        <div className='cardStatus'>
                            Primary Card
                        </div>
                    </> :
                    <div className={classes.noPaymentMethod}>
                        <span>No payment method available. Please add a card.</span>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="addMoreButton"
                            startIcon={<AddIcon />}
                            disableElevation
                            onClick={()=>{setShowMethodModal(true);}}
                        >
                            Add New Card
                        </Button>
                    </div>
                }

            </div>

            {
                showManageModal &&
                (<ManageMethodModal
                    open={showManageModal}
                    onClose={() => setShowManageModal(false)}
                />)
            }

            {showMethodModal && (
                <AddPaymentMethodModal
                    open={showMethodModal}
                    onClose={() => setShowMethodModal(false)}
                    loadData={()=>{
                        dispatch(fetchUserCardInfo({}));
                    }}
                />
            )}
        </div>
    );
};

export default PaymentMethod;